import React from 'react'
import { DrawerHeaderWrapper } from './styles'
import { useDrawer } from '..'

const DrawerHeaderClose = () => {
  const { onClose } = useDrawer()
  return (
    <button
      className="close-button"
      onClick={() => onClose()}
      aria-label="Close"
    >
      <svg
        className="close-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00048 7.05732L11.3005 3.75732L12.2431 4.69999L8.94315 7.99999L12.2431 11.3L11.3005 12.2427L8.00048 8.94266L4.70048 12.2427L3.75781 11.3L7.05781 7.99999L3.75781 4.69999L4.70048 3.75732L8.00048 7.05732Z"
          fill="#2D3748"
        />
      </svg>
    </button>
  )
}

const DrawerHeader = ({ children }) => {
  return <DrawerHeaderWrapper>{children}</DrawerHeaderWrapper>
}

DrawerHeader.displayName = 'DrawerHeader'
DrawerHeader.Title = ({ children }) => <div className="title">{children}</div>
DrawerHeader.Close = DrawerHeaderClose

export default DrawerHeader
